export default __webpack_public_path__ + "static/admin-document-489bc830a5d4d6cefc4a6fcb948f470c.jpg";